import isString from 'lodash/isString';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Menu as InjectMenu} from './Menu';

import { Tooltip as Tooltip } from "~/native-ui/Tooltip";
import {SpinnerButton as InjectButton} from '~/native-ui/Button';

const factory = (Button, Menu, Tooltip = ({ children }) => children) => {
  class IconMenu extends Component {
    static propTypes = {
      config: PropTypes.object,
      children: PropTypes.node,
      className: PropTypes.string,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]),
      iconRipple: PropTypes.bool,
      inverse: PropTypes.bool,
      menuRipple: PropTypes.bool,
      onClick: PropTypes.func,
      onHide: PropTypes.func,
      onSelect: PropTypes.func,
      onShow: PropTypes.func,
      position: PropTypes.string,
      selectable: PropTypes.bool,
      label: PropTypes.string,
      selected: PropTypes.node,
      theme: PropTypes.shape({
        icon: PropTypes.string,
        iconMenu: PropTypes.string,
      }),
    };

    static defaultProps = {
      className: '',
      icon: 'more-vert',
      iconRipple: true,
      menuRipple: true,
      position: 'auto',
      selectable: false,
    };

    referenceEl = React.createRef();

    state = {
      active: false,
    }

    handleButtonClick = (event) => {
      this.setState({ active: !this.state.active });
      if (this.props.onClick) this.props.onClick(event);
    };

    handleMenuHide = () => {
      this.setState({ active: false });
      if (this.props.onClose) this.props.onClose();
    }

    getIconIdentifier() {
      return isString(this.icon) ? this.icon : null
    }

    getIconChild() {
        return isString(this.icon) ? '' : this.icon;
    }

    getMenuProps() {
      const {
        children, icon, iconRipple, inverse, menuRipple, onOpen, config = {},// eslint-disable-line
        onSelect, onShow, position, selectable, selected, theme, label, buttonProps = {}, iconClassName, menuProps = {}, ...other
      } = this.props;

      return {
        ...menuProps,
        onOpen,
        other,
        trigger: this.renderTriggerIcon,
        active: this.state.active,
        onClose: this.handleMenuHide,
        onSelect: onSelect,
        onShow: onShow,
        position: position,
        ripple: menuRipple,
        selectable: selectable,
        selected: selected,
        theme: theme,
        config: config,
        children
      }
    }

    renderTriggerIcon = (props) => {
      const { icon, iconFamily, label, tooltip, buttonProps = {} } = this.props;

      const triggerProps = {
        type: "link",
        ...buttonProps,
        ...props,
        icon,
        iconFamily,
        label,
        onPress: this.props.onClick ? this.handleButtonClick : props.onPress,
      }

      if (tooltip) {
        return <Tooltip tooltip={tooltip}>{ <Button { ...triggerProps } /> }</Tooltip>
      }

      
      return <Button { ...triggerProps } />
    }

    render() {
      const { other, ...menuProps } = this.getMenuProps();
      return (
          <Menu { ...menuProps }></Menu>
      );
    }
  }

  return IconMenu;
};

const IconMenu = factory(InjectButton, InjectMenu, Tooltip);
export { factory as iconMenuFactory };
export default IconMenu;
export { IconMenu };
